import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import api from "../../services/api";
import { MdOutlineEmail, MdOutlineError } from "react-icons/md";
import { AiOutlineEye } from "react-icons/ai";
import { BiMouseAlt } from "react-icons/bi";
import { FiMail } from "react-icons/fi";
import Pagination from "../../components/Paginator";

const getEventStats = (events) => {
  return {
    delivered: events.filter((e) => e === "delivered").length,
    opened: events.filter((e) => e === "opened" || e === "unique_opened").length,
    clicked: events.filter((e) => e === "click").length,
    bounced: events.filter((e) => e === "bounce").length,
  };
};
const Emails = ({ user }) => {
  const [emails, setEmails] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    page: 0,
    per_page: 10,
    emails: [user.email],
  });

  useEffect(() => {
    fetchEmails();
  }, [user, filters]);

  const fetchEmails = async () => {
    try {
      setLoading(true);
      const { ok, data, total, error } = await api.post("/email-event/search", filters);

      console.log("data", data);
      if (!ok) throw new Error(error || "Failed to fetch emails");
      setEmails(data || []);
      setTotal(total || 0);
    } catch (error) {
      console.error("Error fetching emails:", error);
      toast.error("Could not load email data");
    } finally {
      setLoading(false);
    }
  };

  const getEventIcon = (event) => {
    switch (event) {
      case "delivered":
        return <FiMail className="text-green-500" />;
      case "opened":
      case "unique_opened":
        return <AiOutlineEye className="text-blue-500" />;
      case "click":
        return <BiMouseAlt className="text-purple-500" />;
      case "bounce":
        return <MdOutlineError className="text-red-500" />;
      default:
        return <MdOutlineEmail className="text-gray-500" />;
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    // Format time
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    const timeString = `${formattedHours}:${formattedMinutes} ${ampm}`;

    if (diffDays === 0) {
      return `Today at ${timeString}`;
    } else if (diffDays === 1) {
      return `Yesterday at ${timeString}`;
    } else {
      return `${diffDays} days ago at ${timeString}`;
    }
  };

  const renderEventBadges = (events) => {
    if (!events || events.length === 0) return null;

    return (
      <div className="flex flex-wrap gap-1 mt-1">
        {events.map((event, idx) => (
          <span key={idx} className="text-xs px-2 py-0.5 rounded-full bg-gray-100 text-gray-700 capitalize">
            {event}
          </span>
        ))}
      </div>
    );
  };

  return (
    <div className="p-4">
      <h2 className="text-xl font-semibold mb-4">Email Activity</h2>

      {loading ? (
        <div className="flex justify-center items-center h-40">
          <div className="animate-pulse text-gray-500">Loading emails...</div>
        </div>
      ) : emails.length === 0 ? (
        <div className="bg-gray-50 rounded-lg p-6 text-center">
          <MdOutlineEmail className="mx-auto text-4xl text-gray-400 mb-2" />
          <p className="text-gray-500">No email activity found for this user</p>
        </div>
      ) : (
        <>
          <div className="bg-white rounded-lg shadow overflow-hidden">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Event</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Sender</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {emails.map((email, index) => (
                  <tr
                    key={index}
                    className="hover:bg-gray-50"
                    onClick={() => {
                      const EventId = email.raw?.[0]?._id;
                      window.open(`/email-events/${EventId}`, "_blank");
                    }}>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        <div className="text-sm text-gray-900 truncate max-w-xs">{email.subject || "No subject"}</div>
                        {getEventIcon(email.event)}
                      </div>
                      {renderEventBadges(email.events)}
                    </td>
                    <td className="px-6 py-4">
                      <div className="text-xs text-gray-500">{email.sender}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{formatDate(email.created_at)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="mt-4">
            <Pagination page={filters.page + 1} setPage={(page) => setFilters({ ...filters, page })} last={Math.ceil(total / filters.per_page)} />
          </div>
        </>
      )}
    </div>
  );
};

export default Emails;
